import { render, staticRenderFns } from "./blocker.vue?vue&type=template&id=7525315f&scoped=true&"
import script from "./blocker.vue?vue&type=script&lang=js&"
export * from "./blocker.vue?vue&type=script&lang=js&"
import style0 from "./blocker.vue?vue&type=style&index=0&id=7525315f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7525315f",
  null
  
)

export default component.exports